<mat-card class="donut-card">
  <div class="card-container">
    <h3 class="card-title">{{ title }}</h3>

    @if (segments().length > 0) {
      <div class="content-row">
        <!-- SVG Диаграмма -->
        <div class="chart-section">
          <svg viewBox="0 0 240 240" class="donut-svg">
            @for (segment of segments(); track $index) {
              <path
                [attr.d]="describeArc(120, 120, 60, segment.startAngle, segment.endAngle)"
                [attr.stroke]="segment.color"
                stroke-width="20"
                fill="none"
                stroke-linecap="round"
              />

              <!-- Процент на сегменте -->
              @if (segment.percentage >= 10) {
                <text
                  [attr.x]="getLabelPosition(segment, 60, 120, 120).x"
                  [attr.y]="getLabelPosition(segment, 60, 120, 120).y"
                  text-anchor="middle"
                  dominant-baseline="central"
                  class="segment-label"
                >
                  {{ segment.percentage | number: '1.0-0' }}%
                </text>
              }
            }

            <!-- Центр: 100% -->
            <text
              x="120"
              y="120"
              text-anchor="middle"
              dominant-baseline="central"
              class="center-label"
            >
              100%
            </text>
          </svg>
        </div>

        <!-- Легенда -->
        <div class="legend-section">
          <!-- Всего квот -->
          <div class="legend-row">
            <div class="legend-label">
              <span class="legend-dot" [style.background]="C_TOTAL"></span>
              <span>{{ 'dashboard.totalQuotas' | translate }}</span>
            </div>
            <div class="legend-value">
              {{ stats().totalTons }}
              <span class="legend-percentage">(100%)</span>
            </div>
          </div>

          <!-- Распределено -->
          <div class="legend-row">
            <div class="legend-label">
              <span class="legend-dot" [style.background]="C_ALLOCATED"></span>
              <span>{{ 'dashboard.allocated' | translate }}</span>
            </div>
            <div class="legend-value">
              {{ stats().allocatedTons }}
              <span class="legend-percentage">
                ({{ stats().allocatedPct }}%)
              </span>
            </div>
          </div>

          <!-- Остаток -->
          <div class="legend-row">
            <div class="legend-label">
              <span class="legend-dot" [style.background]="C_REMAIN"></span>
              <span>{{ 'dashboard.remaining' | translate }}</span>
            </div>
            <div class="legend-value">
              {{ stats().remainingTons }}
              <span class="legend-percentage">
                ({{ stats().remainingPct }}%)
              </span>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <!-- Нет данных -->
      <div class="no-data-container">
        <div class="no-data-message">{{ 'dashboard.noData' | translate }}</div>
      </div>
    }
  </div>
</mat-card>
